// src/components/confirm/RegistrationConfirmView.tsx
import { useState } from 'react';
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const APP_VARIANT = import.meta.env.VITE_APP_VARIANT;

export default function RegistrationConfirmView() {
  const { t } = useTranslation();
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'failed' | 'invalid'>('idle');

  // IDs aus der URL auslesen
  const params = new URLSearchParams(window.location.search);
  const registrationId = params.get('registration');
  const participantId = params.get('participant');

  const MIDDLEWARE_URL: string = import.meta.env.VITE_MIDDLEWARE_URL;

  const handleConfirmClick = async () => {
    if (!registrationId) {
      setStatus('invalid');
      return;
    }

    setStatus('loading');

    try {
      const res = await fetch(`${MIDDLEWARE_URL}/registrations/opt-in-confirmation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ registration: registrationId, participant: participantId }),
      });

      if (res.ok) {
        setStatus('success');
      } else {
        setStatus('failed');
      }
    } catch (err) {
      setStatus('failed');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{t('confirmation.title')}</h1>

      {status === 'idle' && (
        <>
          <p style={{ whiteSpace: 'pre-line' }}>{t('confirmation.description')}</p>
          <Button onClick={() => handleConfirmClick()} variant={`${APP_VARIANT === 'QS' ? 'secondary rounded-0' : 'primary rounded-pill'}`}>{t('confirmation.button')}</Button>
        </>
      )}

      {status === 'loading' && <p>{t('confirmation.loading')}</p>}
      {status === 'invalid' && <p>{t('confirmation.invalid')}</p>}
      {status === 'failed' && <p>{t('confirmation.failed')}</p>}
      {status === 'success' && <p>{t('confirmation.success')}</p>}
    </div>
  );
}
